import Reveal from "@/components/Reveal";

export default function SectionHead({ label, title, dark = false, center = false, className = "" }) {
  return (
    <Reveal className={`${center ? "text-center" : ""} ${className}`}>
      <p className={dark ? "mono-label-dark" : "mono-label"}>{label}</p>
      <h2 className={`mt-4 font-serif text-3xl font-medium leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-navy" : "text-ivory"}`}>
        {title}
      </h2>
      <div className={`gold-hairline mt-6 ${center ? "mx-auto" : ""}`} />
    </Reveal>
  );
}
